// Libraries
import styled from 'styled-components'

// Custon
import { MainButton } from 'components/UI/Buttons'

export const FormContainer = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 32px 30px 16px 30px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white00};
  input {
    min-width: 100%;
    margin-bottom: 24px;
  }
  textarea {
    min-width: 100%;
    margin-bottom: 24px;
  }
  ${MainButton} {
    margin-top: 16px;
    min-height: 35px;
    ::after {
      content: '';
      margin-left: 13px;
      border: solid white;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 2px;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
      width: 108px;
      align-self: flex-end;
    }
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    max-width: 488px;
  }
`

export const FormTitle = styled.h1`
  margin: 0px 0px 4px 0px;
  font-family: ${({ theme }) => theme.fontFamily.lato};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  font-size: ${({ theme }) => theme.fontSize.xxsmall};
  color: ${({ theme }) => theme.colors.gray02};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    font-size: ${({ theme }) => theme.fontSize.p};
  }
`

export const FormSubTitle = styled.h2`
  margin: 0px 0px 15px 0px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: 10px;
  color: ${({ theme }) => theme.colors.gray03};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    font-size: ${({ theme }) => theme.fontSize.small};
  }
`
